<template>
  <hr class="phxsg-divider" role="separator" />
</template>
